import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroPerfilesService {
  private readonly perfilesUrl: string;

  constructor(private httpClient: HttpClient) {
    this.perfilesUrl = environment.apiUrl + '/administrador/perfiles/total';
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.perfilesUrl);
  }
}
